import { useEffect, useState } from "react";
import CalendarDays from "./CalenderDays";
import LeftArrowIcon from "../../Assets/Icons/linear/arrow-left-1.svg";
import RightArrowIcon from "../../Assets/Icons/linear/arrow-right-1.svg";
import CalendarIcon from "../../Assets/Icons/linear/calendar.svg";

const Calendar = () => {
  const weekdays = ["S", "M", "T", "W", "T", "F", "S"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [currentDay, setCurrentDay] = useState(new Date());

  const [currentMonth, setCurrentMonth] = useState(new Date()?.getMonth());
  const [currentYear, setCurrentYear] = useState(new Date()?.getFullYear());

  const changeCurrentDay = (day) => {
    setCurrentDay(new Date(day.year, day.month, day.number));
  };

  const nextMonth = () => {
    if (currentMonth >= 12) {
      setCurrentMonth(1);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const previousMonth = () => {
    if (currentMonth <= 1) {
      setCurrentMonth(12);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  useEffect(() => {
    let date = new Date();
    setCurrentDay(
      new Date(
        new Date(date).setFullYear(
          currentYear,
          currentMonth,
          currentDay?.getDate()
        )
      )
    );
  }, [currentMonth, currentYear]);

  return (
    <div className="flex flex-col mt-2 mx-auto rounded-3xl shadow-[0_4px_16px_0_rgba(0,0,0,0.3)] mb-8">
      <div className="flex items-center justify-between w-full bg-black text-white rounded-3xl px-5 py-1">
        <div className="flex items-center">
          <div className="me-3">
            <img src={CalendarIcon} className="w-[40px] h-[50px]" alt="" />
          </div>
          <div className="text-xl font-semibold pt-1">
            {months[currentDay.getMonth()]} {currentDay.getFullYear()}
          </div>
        </div>
        <div className="flex items-center">
          <button
            className="p-1 bg-white border rounded-xl me-3"
            type="button"
            onClick={previousMonth}
          >
            <img src={LeftArrowIcon} alt="" />
          </button>
          <button
            className="p-1 bg-white border rounded-xl"
            type="button"
            onClick={nextMonth}
          >
            <img src={RightArrowIcon} alt="" />
          </button>
        </div>
      </div>
      <div className="px-5 py-5">
        <div className="w-full flex flex-col border-4 border-black rounded-xl px-3 py-5">
          <div className="h-[60px] w-full flex items-center justify-around">
            {weekdays.map((weekday,index) => {
              return (
                <div key={index} className="w-[40px] text-center font-semibold">
                  <p>{weekday}</p>
                </div>
              );
            })}
          </div>
          <CalendarDays days={currentDay} changeCurrentDay={changeCurrentDay} />
        </div>
      </div>
    </div>
  );
};

export default Calendar;
